// Format helpers for the widget — locale-aware tCO₂e and BRL formatting.

const FALLBACK_LOCALE = 'pt-BR';

export function formatTCO2e(value: number, locale = FALLBACK_LOCALE): string {
  const fmt = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
  return `${fmt.format(value)} tCO₂e`;
}

export function formatBRL(value: number, locale = FALLBACK_LOCALE): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatPercent(value: number, locale = FALLBACK_LOCALE): string {
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  }).format(value);
}

// Categoria humanizada em PT-BR. Espelha as keys que vêm do backend
// (eventos.CategoryBreakdown.Category).
export function humanizeCategory(category: string): string {
  switch (category) {
    case 'deslocamento':
      return 'Deslocamento até o evento';
    case 'hospedagem':
      return 'Hospedagem';
    case 'intra_city':
      return 'Deslocamento intra-cidade';
    case 'energia':
      return 'Energia';
    case 'fnb':
      return 'Alimentação e bebida';
    case 'residuos':
      return 'Resíduos';
    default:
      return category
        .split('_')
        .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
        .join(' ');
  }
}
